import React, { useRef, useCallback } from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { useLanguage } from '../../../../context/LanguageContext';

export interface ContactFormData {
    phone_number: string;
    fax_number: string;
    dialing_code: string;
    email_address: string;
}

interface ContactFormProps {
    data: ContactFormData;
    onChange: (field: keyof ContactFormData, value: string) => void;
}

const PHONE_CODES = [
    { country: 'France', code: '+33' },
    { country: 'Belgique', code: '+32' },
    { country: 'Suisse', code: '+41' },
    { country: 'Luxembourg', code: '+352' },
    { country: 'États-Unis', code: '+1' },
    { country: 'Royaume-Uni', code: '+44' },
    { country: 'Allemagne', code: '+49' },
    { country: 'Espagne', code: '+34' },
    { country: 'Italie', code: '+39' },
    { country: 'Portugal', code: '+351' },
];

const ContactForm = ({ data, onChange }: ContactFormProps) => {
    const { t } = useLanguage();
    
    const phoneNumberRef = useRef<HTMLInputElement>(null);
    const emailAddressRef = useRef<HTMLInputElement>(null);
    
    const handleBlur = useCallback((field: keyof ContactFormData, ref: React.RefObject<HTMLInputElement | null>) => {
        onChange(field, ref.current?.value || '');
    }, [onChange]);

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 2 }}>
                <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('pages.store.contactForm.dialingCode')}
                    value={data.dialing_code}
                    onChange={(e) => onChange('dialing_code', e.target.value)}
                    SelectProps={{
                        MenuProps: {
                            sx: { height: "300px" },
                        },
                    }}
                >
                    {PHONE_CODES.map((item, index) => (
                        <MenuItem key={index} value={item.code}>
                            {item.country} ({item.code})
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
                <TextField
                    inputRef={phoneNumberRef}
                    size="small"
                    fullWidth
                    label={t('pages.store.contactForm.phone')}
                    defaultValue={data.phone_number}
                    onBlur={() => handleBlur('phone_number', phoneNumberRef)}
                    inputProps={{ maxLength: 30 }}
                />
            </Grid>

            <Grid size={{ xs: 12, md: 5 }}>
                <TextField
                    inputRef={emailAddressRef}
                    size="small"
                    fullWidth
                    label={t('pages.store.contactForm.email')}
                    type="email"
                    defaultValue={data.email_address}
                    onBlur={() => handleBlur('email_address', emailAddressRef)}
                    inputProps={{ maxLength: 50 }}
                />
            </Grid>
        </Grid>
    );
};

export default ContactForm;
